import { Navigate } from "react-router-dom";
import { ProtectedRouteProps } from "./types";
import { useAuth } from "../../hooks/useAuth";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";

export function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}